import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { useNavigate } from "react-router-dom";

import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useState({
    companyName: "",
    module: "",
    fromDate: "",
    toDate: "",
  });

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const offset = currentPage * itemsPerPage;
  const currentItems = tableData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(tableData.length / itemsPerPage);
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  
  const fromClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

  const handleClear = () => {
    setFilters({
      fromDate: "",
      toDate: "",
      module: "",
      companyName: "",
    });

    setTableData([]);

    if (fromClassRef.current) fromClassRef.current.value = "";
    if (admissionNoRef.current) admissionNoRef.current.value = "";
    if (barcodeRef.current) barcodeRef.current.value = "";
    if (smsToRef.current) smsToRef.current.checked = false;
  };

  // Retrieve mandatory fields from localStorage
  const academicSessionId = localStorage.getItem("academicSessionId");
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");

  // Function to fetch data
  const fetchData = async (queryParams = {}, resetPage = false) => {
    try {
      const searchParams = new URLSearchParams({
        academic_year_id: academicSessionId,
        org_id: orgId,
        branch_id: branchId,
        ...queryParams,
      });

      const response = await fetch(
        `${ApiUrl.apiurl}TRAINING_PLACEMENT/List/?${searchParams}`
      );
      if (response.ok) {
        const data = await response.json();
        if (data.message === "success") {
          setTableData(data.data);
          if (resetPage) setCurrentPage(0);
        } else {
          setTableData([]);
          alert("No data found!");
        }
      } else {
        alert("Error fetching data.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please check your internet connection.");
    }
  };

  

  // Fetch data on page load
  useEffect(() => {
    fetchData();
  }, []);

  // Handle search button click
  const handleSearch = () => {
    const queryParams = {
      ...(filters.fromDate && { fromdate: filters.fromDate }),
      ...(filters.toDate && { todate: filters.toDate }),
      ...(filters.module && { module: filters.module }),
      ...(filters.companyName && { companyName: filters.companyName }),
    };
    fetchData(queryParams, true);
  };
  


  
  const handleInputChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) {
      return;
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}TRAINING_PLACEMENT/Delete/${id}/`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        setTableData((prevData) => prevData.filter((item) => item.id !== id));
        alert("Record deleted successfully.");
      } else {
        alert("Failed to delete record.");
      }
    } catch (error) {
      console.error("Error deleting record:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}TRAINING_PLACEMENT/Retrieve/${id}/`
      );

      if (response.ok) {
        const data = await response.json();
        if (data.message === "success") {
          console.log("Fetched Data:", data.data);

          // Navigate to /admin/placement and pass data as state
          navigate("/admin/placement", { state: { placementData: data.data } });
        } else {
          alert("No data found!");
        }
      } else {
        alert("Error fetching data. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Something went wrong. Please check your internet connection.");
    }
  };

  const handleNewClick = () => {
    navigate("/admin/placement");
  };




  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT PLACEMENTS/WORKSHOPS/SEMINARS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNewClick}
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-3 mt-3 ">
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="student-name" className="form-label">
                          Company / Organization Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            name="companyName"
                            className="form-control detail"
                            value={filters.companyName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-3 mb-3">
                        <label style={{ fontWeight: "700" }}>
                          Training Module
                        </label>
                        <input
                          type="text"
                          name="module"
                          className="form-control detail"
                          value={filters.module}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label style={{ fontWeight: "700" }}>From Date</label>
                        <input
                          type="date"
                          name="fromDate"
                          className="form-control detail"
                          value={filters.fromDate}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label style={{ fontWeight: "700" }}>To Date</label>
                        <input
                          type="date"
                          name="toDate"
                          className="form-control detail"
                          value={filters.toDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
              
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Company/ Organization Name</th>
                        <th>Training Module</th>
                        <th>Duration</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>HR Name</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((item, index) => (
                          <tr key={item.id}>
                            <td>{offset + index + 1}</td>
                            <td>{item.companyname}</td>
                            <td>{item.module}</td>
                            <td>{item.duration}</td>
                            <td>{item.fromdate}</td>
                            <td>{item.todate}</td>
                            <td>{item.HRName}</td>
                            <td>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item.id);
                                }}
                              >
                                Edit
                              </a>
                            </td>
                            <td>
                              <a href="#" onClick={() => handleDelete(item.id)}>
                                Delete
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {pageCount > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;


